import image from "../../assets/images/trainteam.png"
import {
  Box,
  Typography,
  Container,
  Button,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import Animator from "../../components/Aminator/Animator";
import { useNavigate } from "react-router-dom";
import { useIsMobile } from "../../components/hooks/useIsMobile";


export default function TrainTeam() {
  const HeroSection = styled(Box)(({ theme }) => ({
    position: "relative",
    backgroundColor: "#0A0E1A",
    color: "#fff",
    overflow: "hidden",
    minHeight: `${isMobile ? "100vh" : "474px"}`,
    marginTop: 0,
    display: "flex",
    alignItems: "center",
    padding: { xs: theme.spacing(4, 2), md: theme.spacing(4, 10) },
    backgroundImage: `url(${image})`,
    backgroundSize: "cover",
    backgroundPosition: "right center",
    backgroundRepeat: "no-repeat",

    "&::before": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      zIndex: 1,
      background: "linear-gradient(90deg, rgba(10,14,26,0.95) 0%, rgba(10,14,26,0.8) 40%, rgba(10,14,26,0.4) 100%)"
    },
  }));

  const ContentContainer = styled(Container)(({ theme }) => ({
    position: "relative",
    zIndex: 2,
    display: "flex",
    flexDirection: "column",

    [theme.breakpoints.up("md")]: {
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "center"
    },
  }));

  const TextContent = styled(Box)(({ theme }) => ({
    // paddingLeft: theme.spacing(4),
    [theme.breakpoints.up("md")]: {
      width: "100%",
      // paddingRight: theme.spacing(4),
      // paddingLeft: theme.spacing(8),
    },
    [theme.breakpoints.down("xs")]: {
      width: "100%",
      // paddingRight: theme.spacing(0),
    },
  }));

  const DarkButton = styled(Button)(({ theme }) => ({
    backgroundColor: "#F05A19",
    color: "#fff",
    padding: theme.spacing(1, 2),
    borderRadius: "8px",
    textTransform: "none",
    fontWeight: 600,
    "&:hover": {
      backgroundColor: "#222222",
    },
  }))

  const isMobile = useIsMobile();
  const navigate = useNavigate();
  return (
    <HeroSection>
      <ContentContainer maxWidth="false">
        <TextContent>
          <Animator variant="slide" direction="right" timeout={800} delay={300} >
            <Typography
              variant="h2"
              component="h1"
              sx={{
                fontWeight: 600,
                fontSize: { xs: "36px", md: "48px" },
                lineHeight: 1.2,
                fontFamily: "'Montserrat', sans-serif",
                mb: "24px",
                textAlign:"center"
              }}
            >
              Lets Train Your Team To Win
            </Typography>
          </Animator>


          <Animator variant="fade" timeout={800} delay={500}>
            <Box
              sx={{
                display: "flex",
                gap: 2,
                justifyContent: "center"
              }}
            >
              <DarkButton variant="contained" disableElevation onClick={() => {
                navigate("/contact");
              }}>
                Contact Us
              </DarkButton>
            </Box>
          </Animator>
        </TextContent>
      </ContentContainer>
    </HeroSection >
  )
}
